import { useState } from 'react';
import {
  Container,
  Title,
  Description,
  InputContainer,
  Input,
  ErrorMessage,
  Response,
} from './NewsletterSubscribeCard.styles';
import { NerdFaceIcon } from '@/icons/index';
import Button from '@/components/Button/Button';
import validator from 'validator';
import axios from 'axios';

interface Props {
  close?: () => void;
}

const NewsletterSubscribeCard = ({ close }: Props) => {
  const [email, setEmail] = useState(``);
  const [error, setError] = useState(``);
  const [responseMsg, setResponseMsg] = useState(``);
  const [loading, setLoading] = useState(false);

  const onInputChange = (e: any) => {
    setEmail(e.target.value);
    setError(``);
  };

  const subscribe = async () => {
    const body = {
      email,
    };

    try {
      setLoading(true);
      await axios
        .post(`${process.env.JOBS4DEV_API_HOST}/api/v1/subscriptions`, body, {
          headers: {
            'Content-Type': `application/json`,
          },
        })
        .then((response) => {
          if (response.status === 201) {
            setResponseMsg(`Thank you for subscription!`);
            setTimeout(() => {
              setResponseMsg(``);
              if (close) {
                close();
              } else {
                window.dispatchEvent(new Event(`subscribed`));
              }
            }, 2000);
          }
        });
    } catch (error) {
      setResponseMsg(`Error!`);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = () => {
    if (!email) {
      setError(`Required`);
    } else if (!validator.isEmail(email)) {
      setError(`Invalid email`);
    } else {
      subscribe();
    }
  };

  return (
    <Container>
      {responseMsg ? (
        <Response>{responseMsg}</Response>
      ) : (
        <>
          <Title>
            <NerdFaceIcon /> Subscribe to our newsletter
          </Title>
          <Description>
            Get the most recent articles directly to your inbox
          </Description>
          <InputContainer>
            <Input
              placeholder="Enter email"
              type="email"
              value={email}
              onChange={onInputChange}
              isError={!!error}
            />
            <ErrorMessage>{error}</ErrorMessage>
            <Button disabled={loading} clickHandler={onSubmit}>
              Subscribe
            </Button>
          </InputContainer>
        </>
      )}
    </Container>
  );
};

export default NewsletterSubscribeCard;
